import { eventDurationString } from "@/components/EventBeacon/Utils/eventbeaconDateUtils";
import moment from "moment";
import _ from 'lodash'
import { MINIMUM_ATH_COUNT_IN_ROSTER } from "@/components/Roster/components/AGGrid/constants"
import {ColumnDefinitions} from "@/components/Roster/Pages/RosterAthletes/Objects/ColumnDefinitions";
import staticAthleteColumnsDefinitions from "@/components/Roster/Pages/RosterAthletes/staticAthleteColumnsDefinitions";
import staticCoachColumnDefinitions from "@/components/Roster/components/FinalReview/staticCoachColumnDefinitions";

export const canChangeStep = state => step => {
    let currentStep = state.steps[state.activeStep]
    if(!currentStep.canGoBackwards && step < state.activeStep) {
        return false
    }
    const traversal = state.steps[step]['dependsOn']
    let finder = null
    if (traversal.length) {
        traversal.forEach(element => {
            if (finder) {
                finder = element instanceof Function ? finder[element(state)] : finder[element]
                return;
            }

            finder = state[element];
        })
        return !!(finder)
    }
    return true
}

export const teams = state => {
    return state.event.teams || []
}

export const positions = state => {
    return state.event?.sport?.positions || []
}

export const isTheWrongSport = state => {
    return state.me && state.event && (
        state.me.organization.sport.id != state.event.sport.id ||
        state.me.organization.gender != state.event.gender
    )
}

export const eventLocation = state => {
    const event = state.event
    return [event.locationCity, event.locationState].filter(Boolean).join(', ')
}

export const eventDate = state => {
    const startDate = moment(state.event.startDate);
    const endDate = moment(state.event.endDate);
    return eventDurationString(startDate, endDate, true, true);
}

export const eventSportName = state => formatSport(state.event.sport, state.event.gender)

function formatSport(sport, gender) {
    const sportName = _.startCase(sport.name)
    const genderName = { male: "Boys'", female: "Girls'" }[gender] || ''

    return `${genderName} ${sportName}`
}
export const isValidating = ({ workspace }) => !workspace.validationRequest?.isFinished

export const displayedRoster = state => {
    let emptyAthletesToAdd = MINIMUM_ATH_COUNT_IN_ROSTER - state.roster.length
    if(emptyAthletesToAdd > 0) {
        return [
            ...state.roster,
            ...Array.from({ length: emptyAthletesToAdd }, Object),
        ]
    }
    return state.roster;
}
export const rowToDelete = ({ workspace }) => workspace.rowToDelete

export function currentTeam(state) {
    return findCurrentTeam(state)
}

function findCurrentTeam(state) {
    return state.event.teams.find(t => t.id === state.currentTeamId)
}

export const eventImageUrl = state => {
    const event = state.event
    const image = event.images.find(i => i.isProfile)
    return image && image.url || null
}

export const roleOptions = state => {
    return [
        { value: null, label: "Select your role" },
        ...state.roles.map(role => ({
          value: role.id,
          label: role.name
        }))
      ];
}

export const domain = state => {
    const gender = state.event.gender
    const sport = state.event.sport.name
    switch(sport) {
        case 'lacrosse':
            if(gender === 'male')
                return 'IMLCARecruits' 
            return 'IWLCARecruits'
            break;
        case 'field hockey':
            return 'NFHCARecruits'
            break;
        default:
            return 'SportsRecruits'
    }
}

export const shouldSendToStart = state => {
    const team = findCurrentTeam(state)
    return team && team.isRostered && state.activeStep != 0
}

export const positionAliases = state => {
    let aliases = [];
    _.forEach(state.event.sport.position_aliases, (alias) => {
        aliases[alias.alias.toLowerCase()] = alias.canonical;
    });
    return aliases
}

export const exportFileName = state => {
    let date = new Date();
    return 'roster-' + state.event.name + '-' + date.toISOString() + '.csv'
}

export const optionalErrors = state => {
    let optionalErrors = []
    state.rosterErrors.forEach(function(row, index) {
        Object.keys(row).forEach(function (field) {
            if (row[field].error === true && row[field].isRequired === false) {
                optionalErrors.push({
                    row: index,
                    field_name: field
                })
            }
        })
    })

    return optionalErrors
}

export const userRole = state => {
    return state.auth.nonIntegratedIdentity
        ? state.roles.find(element => element.id === state.auth.nonIntegratedIdentity.roleId)?.name
        : state.auth.integratedIdentity.role
}

export const sportFieldColumnDefinitions = (state, getters) => {
    const fields = state.event ? state.event.sport.rosteringFields : [];

    return ColumnDefinitions.fromSportFields(fields, getters.requiredFields ?? [], state.roster ?? [])
}

export const requiredFields = state => {
    const requiredFields = ['firstName', 'lastName', 'email', 'gradYear', 'jerseyNumber'];

    if (state.event?.isUsaNumberRequired) {
        requiredFields.push('usa_number');
    }

    return requiredFields;
}

export const athleteColumnDefinitions = (state, getters) => {
    return staticAthleteColumnsDefinitions(state.roster, getters.positions)
        .merge(getters.sportFieldColumnDefinitions);
}

export const coachColumnDefinitions = () => {
    return staticCoachColumnDefinitions;
}


export const teamName = state => {
    return state.event && state.event.teams.length ? findCurrentTeam(state).name : ''
}

export const clubTeams = state => state.me ? state.me.organization.teams : []

export const clubAthletes = state => state.me ? state.me.organization.athletes : []

export const authIdentity = state => state.auth.integratedIdentity || state.auth.nonIntegratedIdentity